import React from "react";
import { Box, Typography, Grid, Paper, Button, Container } from "@mui/material";
import { useTheme } from "@mui/material/styles";
import PeopleIcon from "@mui/icons-material/People";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import GavelIcon from "@mui/icons-material/Gavel";
import Layout from "../components/layout/LandingPageLayout";
import {Link} from "react-router-dom";

const ConsultingFirms = () => {
  const theme = useTheme();

  return (
    <Layout>
      <Container maxWidth="lg" sx={{ py: 8 }}>
        {/* Title */}
        <Typography
          variant="h4"
          align="center"
          gutterBottom
          sx={{ fontWeight: "bold", color: theme.palette.primary.main }}
        >
          Empowering Consulting Firms with AI Accounting
        </Typography>

        <Typography
          variant="body1"
          align="center"
          sx={{
            maxWidth: 700,
            mx: "auto",
            color: theme.palette.text.secondary,
            mb: 6,
          }}
        >
          Consulting firms juggle multiple clients, compliance deadlines, and
          reporting needs. Our AI Accountant simplifies operations so you can
          deliver smarter advice, stay compliant, and focus on client growth.
        </Typography>

        {/* Benefits */}
        <Grid container spacing={4} justifyContent="center">
          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <PeopleIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Client Management
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Manage multiple client accounts, documents, and reports with
                ease in a single dashboard powered by AI automation.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <QueryStatsIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Advanced Reporting
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Deliver detailed financial reports, forecasts, and compliance
                summaries to clients instantly with AI-powered accuracy.
              </Typography>
            </Paper>
          </Grid>

          <Grid item xs={12} sm={4}>
            <Paper
              elevation={3}
              sx={{
                p: 4,
                textAlign: "center",
                borderRadius: 3,
                transition: "0.3s",
                "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
              }}
            >
              <GavelIcon
                sx={{ fontSize: 50, color: theme.palette.primary.main, mb: 2 }}
              />
              <Typography variant="h6" gutterBottom>
                Compliance Support
              </Typography>
              <Typography variant="body2" color="text.secondary">
                Automate tax filings, GST returns, and regulatory compliance so
                your firm never misses a deadline.
              </Typography>
            </Paper>
          </Grid>
        </Grid>

        {/* CTA */}
        <Box textAlign="center" mt={6}>
          <Button
            component={Link}
            to="/login"
            variant="contained"
            size="large"
            sx={{
              backgroundColor: theme.palette.primary.main,
              "&:hover": { backgroundColor: theme.palette.primary.dark },
              px: 5,
              py: 1.5,
              borderRadius: 3,
              textTransform: "none",
              fontWeight: "bold",
            }}
          >
            Boost Your Firm with AI Accounting
          </Button>
        </Box>
      </Container>
    </Layout>
  );
};

export default ConsultingFirms;
